"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CountdownTimer = require("./styles/CountdownTimer");
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CountdownTimer = ({
  targetDate,
  onComplete,
  completedMessage
}) => {
  const [timeLeft, setTimeLeft] = (0, _react.useState)({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isCompleted: false
  });
  (0, _react.useEffect)(() => {
    const calculateTimeLeft = () => {
      const endTime = new Date(targetDate).getTime();
      const now = new Date().getTime();
      const difference = endTime - now;
      if (difference <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isCompleted: true
        });
        onComplete?.();
        return;
      }
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds,
        isCompleted: false
      });
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [targetDate, onComplete]);
  if (timeLeft.isCompleted) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "countdown-completed"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: completedMessage || 'countdownTimer.completedMessage'
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "countdown-timer-container",
    "data-cy": "countdown-timer-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, timeLeft.days > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.days), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.days"
  }))), timeLeft.hours > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.hours), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.hours"
  }))), timeLeft.minutes > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.minutes), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.minutes"
  }))), timeLeft.seconds > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.seconds), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, ' ', /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.seconds"
  })))));
};
CountdownTimer.propTypes = {
  targetDate: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]).isRequired,
  onComplete: _propTypes.default.func,
  completedMessage: _propTypes.default.string
};
var _default = exports.default = CountdownTimer;